<template>
  <div class="plugin-wrapper" :style="{height: height}">
    <div class="plugin-push_item">
      <div class="push-item__inner-wrapper">
        <div class="push-item__background">
          <picture>
            <!--
            <source media="(min-width: 1366px)" srcset="../assets/imgs/ads/accident-fdm-soin.jpg, ../assets/imgs/ads/accident-fdm-soin.jpg 2x">
            <source media="(min-width: 1024px)" srcset="../assets/imgs/ads/accident-fdm-soin.jpg, ../assets/imgs/ads/accident-fdm-soin.jpg 2x">
            <source media="(min-width: 768px)" srcset="../assets/imgs/ads/accident-fdm-soin.jpg, ../assets/imgs/ads/accident-fdm-soin.jpg 2x">
            <source media="(min-width: 0px)" srcset="../assets/imgs/ads/accident-fdm-soin.jpg, ../assets/imgs/ads/accident-fdm-soin.jpg 2x">
            <img class=" lazyloaded" alt="Sisley" srcset="../assets/imgs/ads/accident-fdm-soin.jpg 2x" src="../assets/imgs/ads/accident-fdm-soin.jpg">
            -->
            <img class="lazyloaded" :src="source.kv_image" :alt="source.product_desc">
          </picture>
        </div>
        <div class="push-item__content">
          <a :href="source.link" class="push-item__content-link">
            <span class="push-item__cta link-with-arrow">{{source.product_desc}}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import acitonMixins from "@/utils/action.mixins";

export default {
  name: "PushItem",
  mixins: [acitonMixins],
  props: {
    source: {
      type: Object,
      required: true
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  methods: {},
  watch: {
    height() {
      this.height = this.height;
    }
  }
}
</script>

<style lang="scss" scoped>
  .plugin-push_item { height: 100%; }
  .push-item__inner-wrapper { position: relative; display: flex; height: 100%; }
  .push-item__background { position: absolute; width: 100%; height: 100%; overflow: hidden; }
  .push-item__background img { width: 100%; }
  .push-item__content { width: 100%; background-color: #fff; text-align: center; margin: 1rem; padding: 6.25rem 1.25rem; z-index: 1; }
  .push-item__content-link { display: block; text-decoration: none; max-width: 20rem; margin: 0 auto; z-index: 2; }
  .push-item__content-link:before { content: ""; width: 100%; height: 100%; top: 0; left: 0; position: absolute; }
  .push-item__content-link:hover .link-with-arrow { color: #c4926d; }
  .push-item__cta { display: inline; text-decoration: underline; }
  .push-item__content-link:hover .link-with-arrow:after {
    background-image: url(../assets/imgs/icons/arrow-bigger-hover.svg);
    right: -1.4375rem; transform: rotate(-90deg) scale(.9,1.4);
  }
  // 
  .push-item__inner-wrapper {
    .push-item__content { background: none; margin: 0; padding: 0 0 1.25rem; display: flex; align-items: flex-end; }
  }
  @media screen and (min-width: 64em) {
    .push-item__inner-wrapper { min-height: 25rem; }
    .push-item__content { padding: 1.875rem; }
  }
</style>